// === BUNDLE VARIANT SYNC ===
document.addEventListener('change', function(e) {
  if (e.target.matches('.new-custom-bundle-product-variant-inp')) {
    var btn = document.querySelector('.new-custom-bundle-product-btn');
    if (btn) btn.setAttribute('data-id', e.target.value);
  }
});
document.addEventListener('DOMContentLoaded', function() {
  var checked = document.querySelector('.new-custom-bundle-product-variant-inp:checked');
  var btn = document.querySelector('.new-custom-bundle-product-btn');
  if (checked && btn) btn.setAttribute('data-id', checked.value);
});

// ============================================================
// PRODUCT CONFIG — multi-product support
// ============================================================
// Gift variant IDs: [E-Book, Tracker, Premium Scoop, Restore Balm+]
var GIFT_VARIANT_IDS = [44024722915370, 44024723636266, 44024724291626, 44292198826026];
var GIFT_INFO = {};
GIFT_INFO[44024722915370] = { title: 'Dog Wellness E-Book', image: 'https://cdn.shopify.com/s/files/1/0679/6512/4650/files/WhatsAppImage2026-01-27at16.17.02.jpg?v=1769607401' };
GIFT_INFO[44024723636266] = { title: '90 Days Progress Tracker', image: 'https://cdn.shopify.com/s/files/1/0679/6512/4650/files/WhatsAppImage2026-01-27at16.17.02_2.jpg?v=1769607468' };
GIFT_INFO[44024724291626] = { title: 'Wooden Scoop', image: 'https://cdn.shopify.com/s/files/1/0679/6512/4650/files/WhatsAppImage2026-01-27at16.17.03_2.jpg?v=1769607514' };
GIFT_INFO[44292198826026] = { title: 'Restore Balm+', image: 'https://cdn.shopify.com/s/files/1/0679/6512/4650/files/image_90.webp?v=1776098070' };
var TIER_GIFTS = {
  1: [GIFT_VARIANT_IDS[0]],
  2: [GIFT_VARIANT_IDS[0], GIFT_VARIANT_IDS[1], GIFT_VARIANT_IDS[2]],
  3: [GIFT_VARIANT_IDS[0], GIFT_VARIANT_IDS[1], GIFT_VARIANT_IDS[2], GIFT_VARIANT_IDS[3]]
};

var VARIANT_MAP = {
  // Turkey Tail+
  WOOFY_B1G1: 44243981041706,
  WOOFY_B2G2: 44243981074474,
  WOOFY_B3G3: 44243981107242,
  // Dental Fresh+
  DENTAL_B1G1: 44245971959850,
  DENTAL_B2G2: 44245971992618,
  DENTAL_B3G3: 44245972025386,
  // Joint Power+
  JOINT_B1G1: 44245971271722,
  JOINT_B2G2: 44245971304490,
  JOINT_B3G3: 44245971337258,
  // Senior Dog Pack (3 products per pack × N jars)
  SENIOR_B1G1: 44247128211498,
  SENIOR_B2G2: 44247128244266,
  SENIOR_B3G3: 44247128277034,
  // Degenerative Myelopathy
  DM_B1G1: 44290488074282,
  DM_B2G2: 44290488107050,
  DM_B3G3: 44290488139818
};

// Compare-at fallbacks (cents) by variant ID — used when Shopify cart doesn't return compare_at
var COMPARE_BY_VID = {};
// Turkey Tail+
COMPARE_BY_VID[44243981041706] = 10570;
COMPARE_BY_VID[44243981074474] = 22430;
COMPARE_BY_VID[44243981107242] = 35000;
// Dental Fresh+
COMPARE_BY_VID[44245971959850] = 9970;
COMPARE_BY_VID[44245971992618] = 22430;
COMPARE_BY_VID[44245972025386] = 33400;
// Joint Power+
COMPARE_BY_VID[44245971271722] = 9970;
COMPARE_BY_VID[44245971304490] = 22430;
COMPARE_BY_VID[44245971337258] = 33400;
// Senior Dog Pack
COMPARE_BY_VID[44247128211498] = 11970;
COMPARE_BY_VID[44247128244266] = 23940;
COMPARE_BY_VID[44247128277034] = 35910;
// Degenerative Myelopathy
COMPARE_BY_VID[44290488074282] = 10570;
COMPARE_BY_VID[44290488107050] = 22430;
COMPARE_BY_VID[44290488139818] = 35000;

// Bundle selling prices (cents) by variant ID — for optimistic UI
var PRICE_BY_VID = {};
PRICE_BY_VID[44243981041706] = 4290;
PRICE_BY_VID[44243981074474] = 7990;
PRICE_BY_VID[44243981107242] = 10990;
PRICE_BY_VID[44245971959850] = 4290;
PRICE_BY_VID[44245971992618] = 7990;
PRICE_BY_VID[44245972025386] = 10990;
PRICE_BY_VID[44245971271722] = 3990;
PRICE_BY_VID[44245971304490] = 7990;
PRICE_BY_VID[44245971337258] = 10990;
PRICE_BY_VID[44247128211498] = 7990;
PRICE_BY_VID[44247128244266] = 12990;
PRICE_BY_VID[44247128277034] = 18990;
// Degenerative Myelopathy
PRICE_BY_VID[44290488074282] = 4290;
PRICE_BY_VID[44290488107050] = 7990;
PRICE_BY_VID[44290488139818] = 10990;

var VARIANT_TITLE_BY_POS = { 1: '1+1 FREE', 2: '2+2 FREE', 3: '3+3 FREE' };

var BUNDLE_NAMES = { 1: 'B1G1', 2: 'B2G2', 3: 'B3G3' };
var DAYS_PER_JAR = { Toy: 60, Small: 30, Medium: 20, Large: 15 };
var JARS_BY_POS = { 1: 2, 2: 4, 3: 6 };
var UPGRADE_COPY = {
  1: { sub: 'Buy 2 Get 2 Free \u2014 best results guaranteed' },
  2: { sub: 'Buy 3 Get 3 Free \u2014 maximum protection' }
};
// Per-variant override: used by buildUpgradeToggle before falling back to UPGRADE_COPY
var UPGRADE_COPY_BY_VID = {};
UPGRADE_COPY_BY_VID[44247128211498] = { title: 'Upgrade to Results Pack', sub: '3\u00d72 \u2014 best results guaranteed' };
UPGRADE_COPY_BY_VID[44247128244266] = { title: 'Upgrade to Full Protection Pack', sub: '3\u00d73 \u2014 maximum protection' };
// Variants that should NOT show the upgrade toggle in cart drawer.
// Senior Dog Pack: tier selection happens on the PDP (not in cart).
// Dental Fresh+: upgrade temporarily disabled.
var UPGRADE_EXCLUDED_VIDS = {};
UPGRADE_EXCLUDED_VIDS[44247128211498] = 1; // Senior Tier 1
UPGRADE_EXCLUDED_VIDS[44247128244266] = 1; // Senior Tier 2
UPGRADE_EXCLUDED_VIDS[44247128277034] = 1; // Senior Tier 3
UPGRADE_EXCLUDED_VIDS[44245971959850] = 1; // Dental B1G1
UPGRADE_EXCLUDED_VIDS[44245971992618] = 1; // Dental B2G2
UPGRADE_EXCLUDED_VIDS[44245972025386] = 1; // Dental B3G3
var HIDDEN_PROPS = ['Bundle'];
var EMPTY_CART_IMG = 'https://cdn.shopify.com/s/files/1/0679/6512/4650/files/woofy_golden_tilted.jpg?v=1775716598';
// To enable subscriptions: pass selling_plan ID in ATC items array

// ============================================================
// PERFORMANCE — local cart cache + debounced validation
// ============================================================
var _cartState = null;
var _validateTimer = null;
var _upgradeInProgress = false;
var _pendingRemovals = {};
var _cartIsClearing = false;

function cacheCart(cart) { _cartState = cart; updateCartBubble(cart.item_count); }

function renderFromCache() {
  if (!_cartState || !_cartState.items.length) { renderEmptyState(); return; }
  renderFilledState(_cartState);
}

function showSkeleton() {
  var body = document.getElementById('scd-body');
  var footer = document.getElementById('scd-footer');
  if (!body) return;
  var s = '';
  for (var i = 0; i < 2; i++) {
    s += '<div class="scd-skeleton-item"><div class="scd-skeleton-img scd-shimmer"></div>';
    s += '<div class="scd-skeleton-lines"><div class="scd-skeleton-line scd-shimmer" style="width:70%"></div>';
    s += '<div class="scd-skeleton-line scd-shimmer" style="width:50%"></div>';
    s += '<div class="scd-skeleton-line scd-shimmer" style="width:30%"></div></div></div>';
  }
  body.innerHTML = s;
  if (footer) footer.innerHTML = '<div class="scd-skeleton-line scd-shimmer" style="width:100%;height:44px;border-radius:8px;margin:12px 0"></div>';
}

function scheduleValidation() {
  clearTimeout(_validateTimer);
  _validateTimer = setTimeout(syncCartWithServer, 400);
}

function syncCartWithServer() {
  if (_upgradeInProgress) return;
  fetchCart().then(function(cart) {
    if (_upgradeInProgress) return;
    // Clearing guard: if a full-clear is in progress, skip stale fetches that still show items.
    // Only confirm empty silently when the server returns 0 non-gift items.
    if (_cartIsClearing) {
      var realItemsSync = cart.items.filter(function(i) { return GIFT_VARIANT_IDS.indexOf(i.variant_id) === -1; });
      if (realItemsSync.length === 0) {
        _cartIsClearing = false;
        cacheCart(cart);
      }
      return;
    }
    // Clear pending removals for variants confirmed absent from server cart
    var serverVids = {};
    cart.items.forEach(function(i) { serverVids[i.variant_id] = true; });
    Object.keys(_pendingRemovals).forEach(function(vid) { if (!serverVids[vid]) delete _pendingRemovals[vid]; });
    cacheCart(cart);
    if (cart.items.length === 0) { renderEmptyState(); return; }
    validateGiftState(cart, function(v) {
      if (_upgradeInProgress) return;
      if (v) { cacheCart(v); renderFromCache(); return; }
      fetchCart().then(function(f) { cacheCart(f); if (f.items.length === 0) renderEmptyState(); else renderFromCache(); });
    });
  }).catch(function() {});
}

// OPT 7: preload cart on page load
document.addEventListener('DOMContentLoaded', function() {
  fetchCart().then(function(cart) { cacheCart(cart); }).catch(function() {});
});
// ============================================================

// ============================================================
// FETCH HELPERS
// ============================================================
// safeFetch — 20s timeout, for mutations (add/change/update)
function safeFetch(url, options) {
  var controller = new AbortController();
  var timeout = setTimeout(function() { controller.abort(); }, 20000);
  var opts = Object.assign({}, options || {}, { signal: controller.signal });
  return fetch(url, opts).then(function(r) {
    clearTimeout(timeout); return r;
  }).catch(function(err) {
    clearTimeout(timeout); throw err;
  });
}

// fetchCart — no timeout, 3 retries, 1.5s delay
function fetchCart() {
  var attempts = 0;
  function attempt() {
    attempts++;
    return fetch('/cart.js')
      .then(function(r) { if (r.ok) return r.json(); throw new Error('Status ' + r.status); })
      .catch(function(err) {
        if (attempts >= 3) throw err;
        return new Promise(function(resolve) { setTimeout(function() { resolve(attempt()); }, 1500); });
      });
  }
  return attempt();
}

// ============================================================
// HELPERS
// ============================================================
function getSupplyLabel(dogSize, bundlePos, variantId) {
  var days = DAYS_PER_JAR[dogSize];
  var product = variantId ? getProductKey(variantId) : null;
  var isSenior = product === 'SENIOR';
  var jars = isSenior ? bundlePos : JARS_BY_POS[bundlePos];
  if (!days || !jars) return null;
  var totalDays = jars * days;
  if (isSenior) {
    if (totalDays >= 30 && totalDays % 30 === 0) {
      var months = totalDays / 30;
      return months === 1 ? '1 month' : months + ' months';
    }
    return totalDays + ' days';
  }
  if (totalDays >= 60 && totalDays % 30 === 0) return (totalDays / 30) + ' months';
  return totalDays + ' days';
}

// --- Subscribe & Save: product-aware supply→plan helpers (shared by PDP ATC + cart upgrade) ---
// Data per product: window.WOOFY_BUNDLE_PRODUCTS[productId] = { plans:[{id,name}], tiers:[{pos,variantId,jars}] }
// Resolve the bundle product id (Shopify) for a tier variant, or null if not a bundle-sub variant.
function bundleProductIdForVariant(variantId) {
  var vid = parseInt(variantId, 10);
  var prods = window.WOOFY_BUNDLE_PRODUCTS || {};
  var ids = Object.keys(prods);
  for (var i = 0; i < ids.length; i++) {
    var tiers = (prods[ids[i]] && prods[ids[i]].tiers) || [];
    for (var j = 0; j < tiers.length; j++) { if (tiers[j].variantId === vid) return ids[i]; }
  }
  return null;
}
// Recognizes the bundle tier variants of ALL wired products (scopes subscription wiring to these).
function isBundleSubVariant(variantId) { return bundleProductIdForVariant(variantId) !== null; }
// Pots for a tier from the product's ordered scale (no DOM); falls back to the shared JARS_BY_POS.
function bundleTierJars(productId, pos) {
  var prod = (window.WOOFY_BUNDLE_PRODUCTS || {})[productId];
  if (prod && prod.tiers) {
    for (var i = 0; i < prod.tiers.length; i++) { if (prod.tiers[i].pos === pos) return prod.tiers[i].jars; }
  }
  return JARS_BY_POS[pos] || 0;
}
// supply_days = pots × pot-duration for the size (DAYS_PER_JAR shared: dosage identical across products).
function bundleSupplyDays(dogSize, jars) {
  var days = DAYS_PER_JAR[dogSize];
  return (days && jars) ? days * jars : 0;
}
// Returns THIS product's plan {id, name} whose normalized interval (1 month = 30 days) equals supplyDays.
function bundlePlanForDays(productId, supplyDays) {
  if (!productId || !supplyDays) return null;
  var prod = (window.WOOFY_BUNDLE_PRODUCTS || {})[productId];
  if (!prod || !prod.plans) return null;
  var match = null;
  prod.plans.forEach(function (p) {
    var m = /every\s+(\d+)?\s*(day|days|month|months)/i.exec(p.name || '');
    if (!m) return;
    var n = m[1] ? parseInt(m[1], 10) : 1;
    var d = /^month/i.test(m[2]) ? n * 30 : n;
    if (d === supplyDays) match = p;
  });
  return match;
}

// Returns all bundle variants derived from VARIANT_MAP
function getAllBundleVariants() {
  var keys = Object.keys(VARIANT_MAP);
  var result = [];
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var product = key.substring(0, key.indexOf('_B'));
    var pos = parseInt(key.charAt(key.indexOf('_B') + 2));
    result.push({ id: VARIANT_MAP[key], pos: pos, product: product });
  }
  return result;
}

function getBundlePos(variantId) {
  var all = getAllBundleVariants();
  for (var i = 0; i < all.length; i++) { if (String(all[i].id) === String(variantId)) return all[i].pos; }
  return 0;
}

function getProductKey(variantId) {
  var all = getAllBundleVariants();
  for (var i = 0; i < all.length; i++) { if (String(all[i].id) === String(variantId)) return all[i].product; }
  return null;
}

// Returns same-product variants for upgrade (e.g. DENTAL_B1G1 → DENTAL_B2G2)
function getSameProductVariants(variantId) {
  var key = getProductKey(variantId);
  if (!key) return [];
  return getAllBundleVariants().filter(function(v) { return v.product === key; });
}

function getGiftDelta(tierPos, cartItems) {
  var target = TIER_GIFTS[tierPos] || [];
  var existing = cartItems.filter(function(i) { return GIFT_VARIANT_IDS.indexOf(i.variant_id) !== -1; }).map(function(i) { return i.variant_id; });
  return target.filter(function(g) { return existing.indexOf(g) === -1; });
}

function scdMoney(cents) { return '$' + (cents / 100).toFixed(2); }

function getPackId(item) {
  return (item.properties && item.properties['_pack_id']) || null;
}

function groupByPack(items) {
  var packs = {};
  var packOrder = [];
  var ungrouped = [];
  var allBundleVids = Object.keys(VARIANT_MAP).map(function(k) { return VARIANT_MAP[k]; });
  // First pass: bucket every item into its pack or ungrouped
  items.forEach(function(item) {
    var pid = getPackId(item);
    if (pid) {
      if (!packs[pid]) packs[pid] = { main: null, gifts: [] };
      if (allBundleVids.indexOf(item.variant_id) !== -1) packs[pid].main = item;
      else if (GIFT_VARIANT_IDS.indexOf(item.variant_id) !== -1) packs[pid].gifts.push(item);
      else ungrouped.push(item);
    } else {
      // Skip gift variants without _pack_id — they are rendered inside their pack only
      if (GIFT_VARIANT_IDS.indexOf(item.variant_id) === -1) ungrouped.push(item);
    }
  });
  // Build packOrder by the position of each pack's main item in cart order
  items.forEach(function(item) {
    var pid = getPackId(item);
    if (pid && packs[pid] && packs[pid].main === item && packOrder.indexOf(pid) === -1) {
      packOrder.push(pid);
    }
  });
  // Append any orphan packs (gifts without a main) at the end
  Object.keys(packs).forEach(function(pid) {
    if (packOrder.indexOf(pid) === -1) packOrder.push(pid);
  });
  return { packs: packs, packOrder: packOrder, ungrouped: ungrouped };
}

function updateCartBubble(count) {
  var bubble = document.getElementById('cart-icon-bubble');
  if (!bubble) return;
  var span = bubble.querySelector('.cart-count-bubble span[aria-hidden]');
  if (span) span.textContent = count;
  var cb = bubble.querySelector('.cart-count-bubble');
  if (cb) cb.style.display = count > 0 ? '' : 'none';
}

// ============================================================
// OPEN / CLOSE
// ============================================================
function showDrawer() {
  document.getElementById('scd-drawer').classList.add('scd-open');
  document.getElementById('scd-overlay').classList.add('scd-visible');
  if (window.innerWidth < 750) document.body.classList.add('overflow-hidden');
}

function openCartDrawer() {
  showDrawer();
  if (_cartState && _cartState.items.length > 0) { renderFromCache(); }
  else { showSkeleton(); }
  syncCartWithServer();
}

function safeOpenCartDrawer() {
  showDrawer();
  if (_cartState) {
    if (_cartState.items.length === 0) renderEmptyState(); else renderFromCache();
    scheduleValidation();
  } else {
    showSkeleton();
    fetchCart().then(function(cart) {
      cacheCart(cart);
      if (cart.items.length === 0) { renderEmptyState(); return; }
      validateGiftState(cart, function(v) {
        if (v) { cacheCart(v); renderFromCache(); return; }
        fetchCart().then(function(f) { cacheCart(f); if (f.items.length === 0) renderEmptyState(); else renderFromCache(); });
      });
    }).catch(function() {
      document.getElementById('scd-body').innerHTML = '<div style="text-align:center;padding:40px;color:#999;">Could not load cart. Please try again.</div>';
      document.getElementById('scd-footer').innerHTML = '';
    });
  }
}

function closeCartDrawer() {
  try {
    document.getElementById('scd-drawer').classList.remove('scd-open');
    document.getElementById('scd-overlay').classList.remove('scd-visible');
  } finally { document.body.classList.remove('overflow-hidden'); }
}

// ============================================================
// INTERCEPTS (capture phase)
// ============================================================
document.addEventListener('click', function(e) {
  var link = e.target.closest('a[href*="/cart"]');
  if (link && !link.closest('#scd-drawer') && !link.closest('.scd-checkout-btn')) {
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); safeOpenCartDrawer();
  }
}, true);

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.header__icon--cart').forEach(function(link) {
    link.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); safeOpenCartDrawer(); }, true);
    link.setAttribute('data-href', link.getAttribute('href'));
    link.removeAttribute('href');
    link.style.cursor = 'pointer';
  });
});

document.addEventListener('click', function(e) {
  if (!e.target.closest('.scd-checkout-btn')) return;
  e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
  window.location.href = '/checkout';
}, true);

// ATC — instant skeleton + single batch POST + _pack_id for distinct line items
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.new-custom-bundle-product-btn');
  if (!btn) return;
  e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();

  var checked = document.querySelector('.new-custom-bundle-product-variant-inp:checked');
  var sizeChecked = document.querySelector('.new-custom-bundle-product-main-inp:checked');
  var vid = checked ? checked.value : null;
  var dogSize = sizeChecked ? sizeChecked.value : '';
  if (!vid) return;

  var pos = parseInt(checked.getAttribute('data-pos')) || 1;
  var bundleName = BUNDLE_NAMES[pos] || 'B1G1';
  var originalText = btn.textContent;
  btn.classList.add('active'); btn.disabled = true;

  // Open drawer immediately with skeleton
  showDrawer();
  showSkeleton();

  // _pack_id ensures each ATC creates a distinct line item + links its gifts
  var packId = Date.now().toString();

  // Build single batch: main product + all gifts for this pack (each with _pack_id)
  var items = [{ id: parseInt(vid), quantity: 1, properties: { 'Bundle': bundleName, 'Dog Size': dogSize, '_pack_id': packId } }];
  var giftsForTier = TIER_GIFTS[pos] || [];
  giftsForTier.forEach(function(gid) {
    items.push({ id: gid, quantity: 1, properties: { '_pack_id': packId } });
  });

  // Subscribe & Save (custom_bundle flow only): attach the subscription plan whose delivery
  // interval matches the supply duration of the selected dog SIZE × TIER, scoped to the
  // resolved bundle product. Only the bundle line (items[0]) gets a selling_plan; gifts stay
  // one-time. Unchecked / non-bundle variant → no selling_plan anywhere.
  var subToggle = document.querySelector('.new-custom-bundle-subscribe-inp');
  var subProductId = bundleProductIdForVariant(vid);
  if (subToggle && subToggle.checked && subProductId) {
    var supplyDays = bundleSupplyDays(dogSize, bundleTierJars(subProductId, pos));
    var plan = bundlePlanForDays(subProductId, supplyDays);
    if (plan) {
      items[0].selling_plan = plan.id;  // bundle line only, plan of the resolved product
    } else {
      console.warn('[Woofy bundle] Subscribe & Save: no selling plan matched supply_days=' + supplyDays +
        ' (product=' + subProductId + ', size=' + dogSize + ', pos=' + pos + '). Bundle added as one-time.');
    }
  }

  // Single POST for main + all gifts
  safeFetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: items })
  })
  .then(function(r) { return r.json(); })
  .then(function(res) {
    if (res.status && res.status >= 400) throw new Error('Add failed');
    // Optimistic render: build state from add response + existing cache
    if (res.items && _cartState) {
      res.items.forEach(function(added) { _cartState.items.push(added); });
      _cartState.item_count = _cartState.items.length;
      var t = 0; _cartState.items.forEach(function(x) { t += x.final_line_price; }); _cartState.total_price = t;
      updateCartBubble(_cartState.item_count);
      renderFromCache();
    }
    // Background: fetchCart to confirm and correct any discrepancies
    return fetchCart();
  })
  .then(function(cart) {
    cacheCart(cart);
    if (cart.items.length === 0) { renderEmptyState(); return; }
    renderFromCache();
  })
  .catch(function(err) {
    console.error('ATC error:', err);
    btn.textContent = 'Please try again';
    setTimeout(function() { btn.textContent = originalText; }, 2000);
    closeCartDrawer();
  })
  .finally(function() { btn.classList.remove('active'); btn.disabled = false; });
}, true);

// ============================================================
// GIFT VALIDATION — self-healing on every render
// ============================================================
function validateGiftState(cart, callback) {
  if (_upgradeInProgress) { callback(cart); return; }
  // Early return if there are no real (non-gift) items — nothing to validate
  var realItemsCheck = cart.items.filter(function(i) { return GIFT_VARIANT_IDS.indexOf(i.variant_id) === -1; });
  if (realItemsCheck.length === 0) { callback(cart); return; }
  // Per-pack validation: check each pack's gifts match its tier
  var grouped = groupByPack(cart.items);
  var updates = {};
  var needsUpdate = false;
  Object.keys(grouped.packs).forEach(function(pid) {
    var pack = grouped.packs[pid];
    if (!pack.main) {
      // Orphan gifts without a main item — remove them
      pack.gifts.forEach(function(g) { updates[g.key] = 0; needsUpdate = true; });
      return;
    }
    var tier = getBundlePos(pack.main.variant_id);
    var expected = tier > 0 ? (TIER_GIFTS[tier] || []) : [];
    pack.gifts.forEach(function(g) {
      if (expected.indexOf(g.variant_id) === -1) { updates[g.key] = 0; needsUpdate = true; }
      else if (g.quantity > 1) { updates[g.key] = 1; needsUpdate = true; }
    });
  });
  // Remove any ungrouped gifts (legacy items without _pack_id that have no bundle)
  var hasLegacyBundle = grouped.ungrouped.some(function(i) { return getBundlePos(i.variant_id) > 0; });
  if (!hasLegacyBundle) {
    grouped.ungrouped.forEach(function(i) {
      if (GIFT_VARIANT_IDS.indexOf(i.variant_id) !== -1) { updates[i.key] = 0; needsUpdate = true; }
    });
  }
  if (needsUpdate) {
    safeFetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) })
      .then(function() { callback(null); }).catch(function() { callback(null); });
  } else {
    callback(cart);
  }
}

// ============================================================
// RENDER
// ============================================================
function renderCartDrawer() {
  // OPT 2: render from cache first, then validate in background
  if (_cartState) {
    if (_cartState.items.length === 0) renderEmptyState(); else renderFromCache();
  }
  syncCartWithServer();
}

function renderEmptyState() {
  var h = '<div class="scd-empty-state">';
  h += '<img class="scd-empty-img" src="' + EMPTY_CART_IMG + '" alt="Woofy" />';
  h += '<div class="scd-empty-heading">Your cart is empty, but your results are just a click away.</div>';
  h += '<button type="button" class="scd-empty-cta" data-scd-shop>SHOP NOW</button>';
  h += '<div class="scd-empty-review"><div class="scd-empty-stars">\u2605\u2605\u2605\u2605\u2605</div>';
  h += '<div class="scd-empty-quote">\u201CI was skeptical at first, but after 6 weeks on Woofy\u2019s Turkey Tail+ my dog Luna has more energy than she\u2019s had in years. Her lumps haven\u2019t grown and her coat is absolutely beautiful. I\u2019ll never stop giving her this.\u201D</div>';
  h += '<div class="scd-empty-reviewer">\u2014 Barbara J., Dog owner</div>';
  h += '<div class="scd-empty-verified">Verified Woofy Customer</div></div></div>';
  document.getElementById('scd-body').innerHTML = h;
  document.getElementById('scd-footer').innerHTML = '';
}

function renderFilledState(cart) {
  var totalSavings = 0;
  var grouped = groupByPack(cart.items);

  // Calculate savings across all items
  cart.items.forEach(function(item) {
    var isBundle = getBundlePos(item.variant_id) > 0;
    var isGift = GIFT_VARIANT_IDS.indexOf(item.variant_id) !== -1;
    var price = item.final_line_price;
    if (isBundle && COMPARE_BY_VID[item.variant_id]) {
      var bc = COMPARE_BY_VID[item.variant_id];
      if (bc > price) totalSavings += bc - price;
    } else if (isGift) {
      totalSavings += item.original_line_price || 0;
    } else {
      var oc = item.original_line_price;
      if (oc > price) totalSavings += oc - price;
    }
  });

  // Filter out items pending removal (prevents ghost flicker)
  var visibleUngrouped = grouped.ungrouped.filter(function(item) { return !_pendingRemovals[item.variant_id]; });

  var html = '';
  var hasVisibleContent = false;
  // Render each pack: main → toggle → gifts
  grouped.packOrder.forEach(function(pid) {
    var pack = grouped.packs[pid];
    if (pack.main) {
      hasVisibleContent = true;
      html += renderMainItem(pack.main);
      html += buildUpgradeToggle(pack.main);
      pack.gifts.forEach(function(g) { html += renderGiftItem(g); });
    }
  });
  // Ungrouped items (legacy items, generic)
  visibleUngrouped.forEach(function(item) { hasVisibleContent = true; html += renderMainItem(item); });

  // If only orphan gifts remain (no bundles), show empty state
  if (!hasVisibleContent) { renderEmptyState(); return; }

  document.getElementById('scd-body').innerHTML = html;

  // Footer
  var f = '';
  if (totalSavings > 0) f += '<div class="scd-savings-line">You\u2019re saving ' + scdMoney(totalSavings) + ' on this order</div>';
  f += '<a href="/checkout" class="scd-checkout-btn">SECURE CHECKOUT \u00B7 ' + scdMoney(cart.total_price) + '</a>';
  var paySource = document.getElementById('scd-payment-icons-source');
  if (paySource) f += '<div class="scd-payment-icons">' + paySource.innerHTML + '</div>';
  f += '<div class="scd-guarantee">Try Risk-Free For 90 Days \u2705</div>';
  document.getElementById('scd-footer').innerHTML = f;
}

function renderMainItem(item) {
  var price = item.final_line_price;
  var dogSize = (item.properties && item.properties['Dog Size']) || '';
  var bundlePos = getBundlePos(item.variant_id);
  // Compare-at: cart data first, then per-variant fallback
  var compare = item.original_line_price;
  if (compare <= price && COMPARE_BY_VID[item.variant_id]) compare = COMPARE_BY_VID[item.variant_id];
  var supplyLabel = dogSize && bundlePos ? getSupplyLabel(dogSize, bundlePos, item.variant_id) : null;
  // ARCH 4: subscription badge
  var hasSub = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;

  var h = '<div class="scd-item">';
  h += '<img class="scd-item-img" src="' + (item.image ? item.image.replace(/(\.[^.]+)$/, '_160x$1') : '') + '" alt="" />';
  h += '<div class="scd-item-info">';
  h += '<div class="scd-item-title">' + item.product_title + '</div>';
  if (item.variant_title) h += '<div class="scd-item-meta">' + item.variant_title + '</div>';
  if (dogSize) h += '<div class="scd-item-meta">Dog Size: ' + dogSize + '</div>';
  if (supplyLabel) h += '<div class="scd-item-meta">Supply: ' + supplyLabel + '</div>';
  if (hasSub) h += '<div class="scd-item-meta scd-sub-badge">' + item.selling_plan_allocation.selling_plan.name + '</div>';
  // Display non-hidden properties for generic items
  if (!bundlePos && item.properties) {
    Object.keys(item.properties).forEach(function(k) {
      if (k.charAt(0) !== '_' && item.properties[k] && HIDDEN_PROPS.indexOf(k) === -1 && k !== 'Dog Size')
        h += '<div class="scd-item-meta">' + k + ': ' + item.properties[k] + '</div>';
    });
  }
  h += '<div class="scd-item-stock"><span class="scd-green-dot"></span> In stock</div>';
  h += '</div><div class="scd-item-prices">';
  if (compare > price) h += '<span class="scd-item-compare">' + scdMoney(compare) + '</span>';
  h += '<span class="scd-item-price">' + scdMoney(price) + '</span>';
  h += '<button class="scd-item-trash" data-scd-change data-key="' + item.key + '" data-qty="0" aria-label="Remove">' +
    '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5">' +
      '<path d="M2 4h12M5.33 4V2.67a1.33 1.33 0 011.34-1.34h2.66a1.33 1.33 0 011.34 1.34V4M6.67 7.33v4M9.33 7.33v4"/>' +
      '<path d="M3.33 4l.67 9.33a1.33 1.33 0 001.33 1.34h5.34a1.33 1.33 0 001.33-1.34L12.67 4"/>' +
    '</svg></button>';
  h += '</div></div>';
  return h;
}

function renderGiftItem(item) {
  var imgSrc = item.image || item.featured_image || '';
  if (imgSrc) imgSrc = imgSrc.replace(/(\.[^.]+)$/, '_160x$1');
  var h = '<div class="scd-item scd-item-gift">';
  if (imgSrc) h += '<img class="scd-item-img" src="' + imgSrc + '" alt="" />';
  h += '<div class="scd-item-info"><div class="scd-item-title">FREE ' + item.product_title + '</div></div>';
  h += '<div class="scd-item-prices"><span class="scd-price-free">FREE</span></div></div>';
  return h;
}

// ============================================================
// UPGRADE TOGGLE
// ============================================================
function buildUpgradeToggle(mainItem) {
  if (UPGRADE_EXCLUDED_VIDS[mainItem.variant_id]) return '';
  var sameProduct = getSameProductVariants(mainItem.variant_id);
  if (sameProduct.length < 2) return '';
  var currentPos = getBundlePos(mainItem.variant_id);
  if (!currentPos || !UPGRADE_COPY[currentPos]) return '';
  var nextPos = currentPos + 1, nextVid = null;
  for (var j = 0; j < sameProduct.length; j++) { if (sameProduct[j].pos === nextPos) { nextVid = sameProduct[j].id; break; } }
  if (!nextVid) return '';
  var dogSize = (mainItem.properties && mainItem.properties['Dog Size']) || '';
  var overrideCopy = UPGRADE_COPY_BY_VID[mainItem.variant_id];
  var supplyLabel = getSupplyLabel(dogSize, nextPos, mainItem.variant_id);
  var title, sub;
  if (overrideCopy) {
    // Per-variant override (e.g. Senior Dog Pack):
    // title = override base + "· N jars each = X supply" (omit supply if dog size unknown)
    // sub   = "$X — Save Y% · Free Shipping"
    var nextPrice = PRICE_BY_VID[nextVid] || 0;
    var nextCompare = COMPARE_BY_VID[nextVid] || 0;
    var savePct = (nextCompare > nextPrice && nextCompare > 0) ? Math.round((nextCompare - nextPrice) / nextCompare * 100) : 0;
    var suffix = (dogSize && supplyLabel) ? (' \u00b7 ' + nextPos + ' jars each = ' + supplyLabel + ' supply') : '';
    title = overrideCopy.title + suffix;
    sub = scdMoney(nextPrice) + (savePct > 0 ? (' \u2014 Save ' + savePct + '%') : '') + ' \u00b7 Free Shipping';
  } else {
    // Existing products (Turkey/Dental/Joint) — unchanged behavior
    title = supplyLabel ? 'Upgrade to ' + supplyLabel + ' supply' : 'Upgrade your supply';
    sub = UPGRADE_COPY[currentPos].sub;
  }
  var packId = (mainItem.properties && mainItem.properties['_pack_id']) || '';
  var fromSub = (mainItem.selling_plan_allocation && mainItem.selling_plan_allocation.selling_plan) ? '1' : '0';
  return '<div class="scd-toggle-row" data-scd-toggle data-from-key="' + mainItem.key + '" data-to-vid="' + nextVid + '" data-to-pos="' + nextPos + '" data-dog-size="' + dogSize + '" data-pack-id="' + packId + '" data-from-sub="' + fromSub + '">' +
    '<div class="scd-toggle-text"><div class="scd-toggle-title">' + title + '</div><div class="scd-toggle-sub">' + sub + '</div></div>' +
    '<label class="scd-toggle-switch"><input type="checkbox" class="scd-toggle-input" /><span class="scd-toggle-slider"></span></label></div>';
}

// ============================================================
// EVENT DELEGATION (bubbling)
// ============================================================
document.addEventListener('click', function(e) {
  if (e.target.closest('[data-scd-close]') || e.target.id === 'scd-overlay') { e.preventDefault(); closeCartDrawer(); return; }
  // Remove item — pack-aware: removes main + all linked gifts by _pack_id
  var changeBtn = e.target.closest('[data-scd-change]');
  if (changeBtn) {
    e.preventDefault();
    var removeKey = changeBtn.getAttribute('data-key');
    var qty = parseInt(changeBtn.getAttribute('data-qty'));

    // Find the item and its _pack_id
    var removedItem = null;
    var removePid = null;
    if (_cartState && qty === 0) {
      for (var ri = 0; ri < _cartState.items.length; ri++) {
        if (_cartState.items[ri].key === removeKey) {
          removedItem = _cartState.items[ri];
          removePid = getPackId(removedItem);
          break;
        }
      }
      // Mark variant as pending removal (prevents ghost flicker on re-render)
      if (removedItem) _pendingRemovals[removedItem.variant_id] = true;
      // Optimistic: remove entire pack (main + gifts) or just the single item
      if (removedItem && removePid && getBundlePos(removedItem.variant_id) > 0) {
        _cartState.items = _cartState.items.filter(function(i) { return getPackId(i) !== removePid; });
      } else {
        _cartState.items = _cartState.items.filter(function(i) { return i.key !== removeKey; });
      }
      var newTotal = 0;
      _cartState.items.forEach(function(i) { newTotal += i.final_line_price; });
      _cartState.total_price = newTotal;
      _cartState.item_count = _cartState.items.length;
      updateCartBubble(_cartState.item_count);
      if (_cartState.items.length === 0) {
        _cartIsClearing = true;
        renderEmptyState();
      } else {
        renderFromCache();
      }
    }

    // Server: batch remove all items with matching _pack_id
    if (removePid && removedItem && getBundlePos(removedItem.variant_id) > 0) {
      fetchCart().then(function(cart) {
        var updates = {};
        cart.items.forEach(function(i) { if (getPackId(i) === removePid) updates[i.key] = 0; });
        if (Object.keys(updates).length) {
          safeFetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) })
            .then(function() { syncCartWithServer(); }).catch(function() { _cartIsClearing = false; syncCartWithServer(); });
        } else { syncCartWithServer(); }
      }).catch(function() { _cartIsClearing = false; });
    } else {
      safeFetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: removeKey, quantity: qty }) })
        .then(function() { syncCartWithServer(); }).catch(function() { _cartIsClearing = false; syncCartWithServer(); });
    }
    return;
  }
  if (e.target.closest('[data-scd-shop]')) { e.preventDefault(); window.location.href = '/collections/our-selection'; return; }
  if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeCartDrawer(); return; }
});

// Upgrade — pack-aware: preserves _pack_id, gifts linked to same pack
document.addEventListener('change', function(e) {
  if (!e.target.matches('.scd-toggle-input')) return;
  var row = e.target.closest('[data-scd-toggle]');
  if (!row) return;
  var toggle = e.target; toggle.disabled = true;
  var fromKey = row.getAttribute('data-from-key');
  var toVid = parseInt(row.getAttribute('data-to-vid'));
  var toPos = parseInt(row.getAttribute('data-to-pos'));
  var dogSize = row.getAttribute('data-dog-size') || '';
  var bundleName = BUNDLE_NAMES[toPos] || '';
  var packId = row.getAttribute('data-pack-id') || '';

  // Sub-aware: if the current line is a subscription, the upgraded line keeps a subscription,
  // on the plan matching the NEW tier's supply (new pots × pot-days for the preserved size).
  var fromSub = row.getAttribute('data-from-sub') === '1';
  // Resolve the product from the TARGET (upgraded) variant — the higher tier is the same product.
  var upgradeProductId = bundleProductIdForVariant(toVid);
  var subScoped = fromSub && !!upgradeProductId;
  // New tier pots read from the product's ordered scale (no DOM in cart context).
  var upgradeSupplyDays = subScoped ? bundleSupplyDays(dogSize, bundleTierJars(upgradeProductId, toPos)) : 0;
  var upgradePlan = subScoped ? bundlePlanForDays(upgradeProductId, upgradeSupplyDays) : null;
  if (subScoped && !upgradePlan) console.warn('[Woofy bundle] Upgrade: no selling plan matched supply_days=' +
    upgradeSupplyDays + ' (product=' + upgradeProductId + ', size=' + dogSize + ', toPos=' + toPos + '). Upgraded as one-time.');

  var prevState = _cartState ? JSON.parse(JSON.stringify(_cartState)) : null;
  _upgradeInProgress = true;

  // Optimistic: transform _cartState in memory and re-render instantly
  if (_cartState) {
    for (var i = 0; i < _cartState.items.length; i++) {
      if (_cartState.items[i].key === fromKey) {
        var item = _cartState.items[i];
        var oldPrice = item.final_line_price;
        var newPrice = PRICE_BY_VID[toVid] || oldPrice;
        var newCompare = COMPARE_BY_VID[toVid] || item.original_line_price;
        item.variant_id = toVid;
        item.variant_title = VARIANT_TITLE_BY_POS[toPos] || item.variant_title;
        item.final_line_price = newPrice;
        item.final_price = newPrice;
        item.price = newPrice;
        item.original_line_price = newCompare;
        item.original_price = newCompare;
        if (item.properties) item.properties['Bundle'] = bundleName;
        if (upgradePlan) item.selling_plan_allocation = { selling_plan: { id: upgradePlan.id, name: upgradePlan.name } };
        item.key = String(toVid) + ':' + Date.now();
        _cartState.total_price = _cartState.total_price - oldPrice + newPrice;
        break;
      }
    }
    // Add missing gifts for new tier optimistically (with _pack_id)
    var newGifts = TIER_GIFTS[toPos] || [];
    var packGiftIds = _cartState.items.filter(function(x) { return GIFT_VARIANT_IDS.indexOf(x.variant_id) !== -1 && getPackId(x) === packId; }).map(function(x) { return x.variant_id; });
    newGifts.forEach(function(gid) {
      if (packGiftIds.indexOf(gid) === -1) {
        var gi = GIFT_INFO[gid] || { title: 'Free Gift', image: '' };
        _cartState.items.push({ variant_id: gid, product_title: gi.title, variant_title: '', final_line_price: 0, original_line_price: 0, price: 0, quantity: 1, image: gi.image, key: String(gid) + ':gift:' + packId, properties: { '_pack_id': packId }, handle: '' });
        _cartState.item_count++;
      }
    });
    updateCartBubble(_cartState.item_count);
    renderFromCache();
  }

  // Background: remove old items for this pack, add new variant + gifts with same _pack_id
  // Step 1: remove all items for this pack
  fetchCart().then(function(cart) {
    var updates = {};
    cart.items.forEach(function(ci) { if (getPackId(ci) === packId) updates[ci.key] = 0; });
    return safeFetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) });
  })
  // Step 2: add new variant + all tier gifts with same _pack_id
  .then(function() {
    var addItems = [{ id: toVid, quantity: 1, properties: { 'Bundle': bundleName, 'Dog Size': dogSize, '_pack_id': packId } }];
    if (upgradePlan) addItems[0].selling_plan = upgradePlan.id;  // keep subscription on the right plan for the new tier
    var tierGifts = TIER_GIFTS[toPos] || [];
    tierGifts.forEach(function(gid) { addItems.push({ id: gid, quantity: 1, properties: { '_pack_id': packId } }); });
    return safeFetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: addItems }) });
  })
  .then(function() { return fetchCart(); })
  .then(function(cart) {
    _upgradeInProgress = false;
    clearTimeout(_validateTimer);
    cacheCart(cart);
    renderFromCache();
    setTimeout(function() { if (!_upgradeInProgress) syncCartWithServer(); }, 5000);
  })
  .catch(function(err) {
    _upgradeInProgress = false;
    clearTimeout(_validateTimer);
    console.error('Upgrade error:', err);
    if (prevState) { _cartState = prevState; updateCartBubble(_cartState.item_count); renderFromCache(); }
    else { syncCartWithServer(); }
  });
});

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    var d = document.getElementById('scd-drawer');
    if (d && d.classList.contains('scd-open')) { closeCartDrawer(); return; }
    var megaOpen = document.querySelector('.wfy-mega-dropdown[open]');
    if (megaOpen) { megaOpen.removeAttribute('open'); megaOpen.querySelector('summary').focus(); }
  }
});

// Expose cart drawer opener for external sections (e.g. senior-dog-bundle)
window.woofyOpenCart = openCartDrawer;
